import { setCookie } from '../commons/helpers/CookiesHelpers';

/**
 * Store utm search params in local storage
 */
const UTM_PARAMS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];
const PREFIX = 'yp_utm_';
const EXPIRATION_MONTHS = 1;

function saveUtm(utmParamName, utmValue) {
    setCookie(`${PREFIX}${utmParamName}`, encodeURIComponent(utmValue), EXPIRATION_MONTHS);
}

function expireUtm(utmParamName) {
    setCookie(`${PREFIX}${utmParamName}`, '', -1);
}

/**
 * Un jeu d'utm remplace le précédent en entier, comme captureUtms (utmHelpers.ts du SPA pro)
 */
function saveUtms() {
    const params = new URLSearchParams(window.location.search);
    if (!UTM_PARAMS.some((utmParamName) => params.has(utmParamName))) return;
    UTM_PARAMS.forEach((utmParamName) => {
        const utmValue = params.get(utmParamName);
        if (!utmValue) {
            expireUtm(utmParamName);
            return;
        }
        saveUtm(utmParamName, utmValue);
    });
}

window.addEventListener('load', saveUtms);
